import asyncActionTypes from '../actions/types';

const initialState = {
  seatFares: null,
};

const seatFare = (state = initialState, action) => {
  if (action.type === asyncActionTypes.CHANGE_SEAT_FARES) {
    return {
      ...state,
      seatFares: action.fares,
    };
  } else {
    return state;
  }
};

export default seatFare;
